import React, { useMemo } from 'react';
import { CardBody, Row } from 'reactstrap';
import { Colxx } from '../../components/common/CustomBootstrap';
import moment from 'moment';
import filter from 'lodash/filter';
import find from 'lodash/find';
import isUndefined from 'lodash/isUndefined';
import forEach from 'lodash/forEach';
import orderBy from 'lodash/orderBy';
import map from 'lodash/map';
import slice from 'lodash/slice';
import { useIntl } from 'react-intl';

import { OrderTypes } from '../../constants/orderTypes';
import { registeredHotels } from '../../constants/travelValues';

export default function HotelCardTopHotels({ orders, reservations }) {
  const { messages } = useIntl();

  const chainsList = useMemo(() => {
    if (!(orders.length && reservations.length)) return [];

    const hotelReservations = filter(reservations, (reservation) => {
      const orderExists = !isUndefined(
        find(orders, (order) => {
          return order.id === reservation.refs.orderId;
        })
      );

      return reservation.type === OrderTypes.HOTEL && orderExists;
    });

    let chainsList = {};
    forEach(hotelReservations, (reservation) => {
      const chainName = reservation.hotelDetails.hotel.chain.name;

      chainsList[chainName] = {
        ...reservation.hotelDetails.hotel,
        ...chainsList[chainName],
      };

      chainsList[chainName].qtd = isUndefined(chainsList[chainName].qtd)
        ? 1
        : chainsList[chainName].qtd + 1;

      const nights = moment(
        reservation.hotelDetails.checkOut,
        'DD/MM/YYYY'
      ).diff(moment(reservation.hotelDetails.checkIn, 'DD/MM/YYYY'), 'days');

      chainsList[chainName].nights = isUndefined(chainsList[chainName].nights)
        ? nights
        : chainsList[chainName].nights + nights;
    });

    return slice(orderBy(chainsList, 'qtd', ['desc']), 0, 5);
  }, [orders, reservations]);

  return (
    <CardBody>
      <Row>
        <Colxx sm="12">
          {map(chainsList, (chain) => {
            return (
              <div
                key={chain.iterpec}
                className="d-flex flex-row mb-3 pb-3 justify-content-between align-items-center"
              >
                <div
                  className="chain-image"
                  style={{
                    backgroundImage: `url(${
                      registeredHotels[chain.chain.name]
                        ? registeredHotels[chain.chain.name].logo
                        : '/assets/img/icons/search_icon_hotel.svg'
                    })`,
                  }}
                />
                <div className="flex-fill pl-2">
                  <p className="font-weight-medium mb-0">
                    {chain.chain.name || chain.name}
                  </p>
                </div>
                <div className="pr-2">
                  {chain.qtd} {messages['general.reservations']}
                </div>
                <div className="pl-2">
                  {chain.nights} {messages['general.nights']}
                </div>
              </div>
            );
          })}
        </Colxx>
      </Row>
    </CardBody>
  );
}
